/**
 * Search slide-over drawer.
 */
(function () {
  var drawer = document.querySelector("[data-search-drawer]");
  if (!drawer) return;

  var input = drawer.querySelector("[data-search-input]");
  var form = drawer.querySelector("[data-search-form]");
  var trending = drawer.querySelector("[data-search-trending]");
  var resultsWrap = drawer.querySelector("[data-search-results]");
  var resultsLabel = drawer.querySelector("[data-search-results-label]");
  var resultsList = drawer.querySelector("[data-search-results-list]");
  var viewAll = drawer.querySelector("[data-search-view-all]");
  var debounceTimer = null;

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    if (input) {
      window.setTimeout(function () {
        input.focus();
      }, 350);
    }
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function getPath(href) {
    if (!href || href === "#") return "";
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return href.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
    }
  }

  function isSearchPath(path) {
    return path === "/search" || /\/search$/i.test(path);
  }

  function isSearchLink(el) {
    if (!el || el.tagName !== "A") return false;
    if (el.hasAttribute("data-search-open")) return true;
    return isSearchPath(getPath(el.getAttribute("href")));
  }

  var trendingReady = false;
  var trendingFilterPromise = null;
  var wantTrending = false;

  function trendingItems() {
    if (!trending) return [];
    return Array.prototype.slice.call(
      trending.querySelectorAll("[data-search-trend]")
    );
  }

  function syncTrendingVisibility() {
    if (!trending) return;
    if (!wantTrending || !trendingReady) {
      trending.hidden = true;
      return;
    }
    var hasVisible = trendingItems().some(function (btn) {
      var li = btn.closest("li");
      return li ? !li.hidden : true;
    });
    trending.hidden = !hasVisible;
  }

  function filterEmptyTrending() {
    if (trendingReady || !trending) {
      return Promise.resolve();
    }
    if (trendingFilterPromise) return trendingFilterPromise;

    var items = trendingItems();
    if (!items.length) {
      trendingReady = true;
      syncTrendingVisibility();
      return Promise.resolve();
    }

    trendingFilterPromise = Promise.all(
      items.map(function (btn) {
        var query = (btn.getAttribute("data-search-trend") || btn.textContent || "").trim();
        var li = btn.closest("li");
        if (!query) {
          if (li) li.hidden = true;
          return Promise.resolve();
        }

        var url =
          "/search/suggest.json?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=hide";

        return fetch(url)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var products =
              (data.resources &&
                data.resources.results &&
                data.resources.results.products) ||
              [];
            if (li) li.hidden = products.length === 0;
          })
          .catch(function () {
            // Keep the preset visible if the check fails
          });
      })
    ).then(function () {
      trendingReady = true;
      trendingFilterPromise = null;
      syncTrendingVisibility();
    });

    return trendingFilterPromise;
  }

  function showTrending() {
    wantTrending = true;
    if (resultsWrap) resultsWrap.hidden = true;
    if (resultsList) resultsList.innerHTML = "";
    if (resultsLabel) resultsLabel.hidden = true;
    if (viewAll) viewAll.hidden = true;
    syncTrendingVisibility();
    filterEmptyTrending().then(syncTrendingVisibility);
  }

  function showResults() {
    wantTrending = false;
    if (trending) trending.hidden = true;
    if (resultsWrap) resultsWrap.hidden = false;
  }

  function renderResults(products, query) {
    if (!resultsList) return;
    resultsList.innerHTML = "";

    if (!products.length) {
      showResults();
      if (resultsLabel) {
        resultsLabel.hidden = false;
        resultsLabel.textContent = "No products found for \"" + query + "\"";
      }
      if (viewAll) viewAll.hidden = true;
      return;
    }

    showResults();
    if (resultsLabel) resultsLabel.hidden = true;

    products.forEach(function (product) {
      var li = document.createElement("li");
      var link = document.createElement("a");
      link.className = "search-drawer__result";
      link.href = product.url;

      if (product.featured_image && product.featured_image.url) {
        var img = document.createElement("img");
        img.src = product.featured_image.url;
        img.alt = product.featured_image.alt || product.title;
        img.width = 72;
        img.height = 96;
        img.loading = "lazy";
        link.appendChild(img);
      }

      var title = document.createElement("span");
      title.className = "search-drawer__result-title";
      title.textContent = product.title;
      link.appendChild(title);

      if (product.price) {
        var price = document.createElement("span");
        price.className = "search-drawer__result-price";
        price.textContent = product.price;
        link.appendChild(price);
      }

      li.appendChild(link);
      resultsList.appendChild(li);
    });

    if (viewAll) {
      viewAll.hidden = false;
      viewAll.href = "/search?q=" + encodeURIComponent(query);
    }
  }

  function fetchSuggestions(query) {
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide";

    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        renderResults(products, query);
      })
      .catch(function () {
        renderResults([], query);
      });
  }

  function runSearch(query) {
    query = (query || "").trim();
    if (!query) {
      showTrending();
      return;
    }
    fetchSuggestions(query);
  }

  function scheduleSearch() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      runSearch(input ? input.value : "");
    }, 280);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-open]") || (function () {
      var link = e.target.closest("a");
      return link && isSearchLink(link);
    })()) {
      e.preventDefault();
      showTrending();
      openDrawer();
      return;
    }

    if (e.target.closest("[data-search-close]")) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.target.closest("[data-search-trend]")) {
      e.preventDefault();
      var btn = e.target.closest("[data-search-trend]");
      var query = btn.getAttribute("data-search-trend") || btn.textContent;
      if (input) input.value = query;
      runSearch(query);
    }
  });

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      runSearch(input ? input.value : "");
    });
  }

  if (input) {
    input.addEventListener("input", scheduleSearch);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  function initFromPage() {
    if (drawer.getAttribute("data-auto-open") !== "true") return;

    var params = new URLSearchParams(window.location.search);
    var q = params.get("q") || "";
    if (input) input.value = q;
    openDrawer();
    if (q) {
      runSearch(q);
    } else {
      showTrending();
    }
  }

  // Warm the empty-query filter so opening Search is instant.
  filterEmptyTrending();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFromPage);
  } else {
    initFromPage();
  }

  window.WearableSearchDrawer = {
    open: openDrawer,
    close: closeDrawer,
  };
})();
